import { RootState } from '../store/configureStore';

export const getAvailableColourGroups = (state: RootState) => state?.colourGroups?.colourGroups;

export const isFetchingAvailableColourGroups = (state: RootState) =>
  state?.colourGroups?.isFetchingColourGroup;

export const didFetchingAvailableColourGroupsFailed = (state: RootState) =>
  state?.colourGroups?.fetchingColourGroupFailed;
